import { createFileRoute } from '@tanstack/react-router';
import { createColumnHelper } from '@tanstack/react-table';
import api from '@/api';
import type { components } from '@/api/qraft/schema';
import { createTablePage } from '~/components/ui/createTablePage';
import { LIST_PAGE_SIZE } from '~/components/ui/Pagination';
import { CreateGroupButton } from './CreateGroupButton';

type GroupItem = components['schemas']['GroupItem'];

const columnHelper = createColumnHelper<GroupItem>();

const columns = [
  columnHelper.accessor('id', {
    header: 'ID',
  }),
  columnHelper.accessor((row) => row.name, {
    id: 'name',
    header: 'Name',
  }),
];

const CongregationsList = createTablePage<GroupItem, '/groups/$groupId'>({
  name: 'Groups',
  useData: (page: number) => {
    return api.getGroups.useQuery({
      query: {
        limit: LIST_PAGE_SIZE,
        offset: LIST_PAGE_SIZE * page,
      },
    });
  },
  columns: columns,
  itemBaseUrl: '/groups/$groupId',
  getParams: (row) => ({ groupId: String(row.id) }),
  actions: <CreateGroupButton />,
});

export const Route = createFileRoute('/_admin/groups/')({
  component: CongregationsList,
});
